import { Serializable } from '@/models/core/serializable';
import { Student } from '@/models/student/student';
import { Big5Score } from '@/models/student/student-karte';
import { Big5 } from '@/models/big5/big5';

export class StatsCharacterMapping implements Serializable<StatsCharacterMapping> {
  data: CharacterMappingData[] = [];
  big5labels: Big5[] = [];

  deserialize(input: any): StatsCharacterMapping {
    this.data = input.data.map((characterMappingData: CharacterMappingData) => new CharacterMappingData().deserialize(characterMappingData));
    this.big5labels = input.big5labels.map((big5: Big5) => new Big5().deserialize(big5));
    return this;
  }
}

export class CharacterMappingData implements Serializable<CharacterMappingData> {
  student: Student;
  value: number[];
  big5scores: Big5Score[];

  deserialize(input: any): CharacterMappingData {
    this.student = new Student().deserialize(input.student);
    this.value = input.value;
    this.big5scores = input.data;
    return this;
  }
}
